import ExerciseGenerator from "./ExerciseGenerator";
import {getRandomIntegerWithRange} from "../Random";
import Exercise from "../Exercise";
import {decimalToBinary} from "../logic/Conversion";
import Modes from "../mode/Modes";
import NumberSystems from "../NumberSystems";
import ResultItem from "../ResultItem";

export default class ConversionExerciseGenerator extends ExerciseGenerator{
    generate = () => {
        const isBinaryAddition =  this.mode.equals(Modes.BINARY_ADDITION);
        const isBinarySubtraction =  this.mode.equals(Modes.BINARY_SUBTRACTION);

        const valueA = getRandomIntegerWithRange(1, 127);
        const valueB = getRandomIntegerWithRange(0, valueA-1);
        const integers = [valueA, valueB];

        let result;
        if(isBinaryAddition){
            result = this.binaryAddition(integers, this.getRandomBitCount());
        }else if(isBinarySubtraction){
            result = this.binarySubtraction(integers);
        }else{
            throw new Error("Invalid arithmetic task");
        }

        const convertedTask = [decimalToBinary(valueA), decimalToBinary(valueB)];

        return new Exercise(
            integers,
            convertedTask,
            result
        );
    };

    convertStringToIntegerArray = (_toConvert) => {
        const toConvert = String(_toConvert).split("");
        const integerArray = [];
        toConvert.forEach((element)=>{
            integerArray.push(Number(element));
        });
        return integerArray;
    };

    binaryAddition = (integers, bitanzahl) => {
        return [
            new ResultItem(
                decimalToBinary(integers[0] + integers[1]),
                NumberSystems.BINARY
            )
        ];
    };
    binarySubtraction = (integers) => {
        return [
            new ResultItem(
                decimalToBinary(integers[0] - integers[1]),
                NumberSystems.BINARY
            )
        ];
    }

}